import { render, staticRenderFns } from "./Syncconfig.vue?vue&type=template&id=9bd3e1d4&"
import script from "./Syncconfig.vue?vue&type=script&lang=js&"
export * from "./Syncconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports